// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"liquor"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M19.5 2.5L21.5 4.5L17 9L17 13L8.70712 21.2929C8.3166 21.6834 7.68343 21.6834 7.29291 21.2929L2.70711 16.7071C2.31658 16.3166 2.31658 15.6834 2.70711 15.2929L11 6.99999L15 7L19.5 2.5Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M8.99998 9L15 15L11 19L5 13L8.99998 9Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1"},"nodeName":"g","children":[{"attributes":{"stroke":"currentColor","d":"M19.4999 2.5L21.4999 4.5L16.9999 9L16.9999 13L8.70697 21.2929C8.31644 21.6834 7.68328 21.6834 7.29276 21.2929L2.70696 16.7071C2.31643 16.3166 2.31643 15.6834 2.70696 15.2929L10.9999 6.99999L14.9999 7L19.4999 2.5Z","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"stroke":"currentColor","d":"M8.99982 9L14.9998 15L10.9998 19L4.99985 13L8.99982 9Z","stroke-width":2},"nodeName":"path","children":[]}]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M9.99805 13.998H10.002V14.002H9.99805V13.998Z","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-liquor')
export default class LiquorIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'liquor',
    }
  }
}
